import File from './file';
import Sound from './sound';

export default {
  File,
  Sound,
};
